// extracted by mini-css-extract-plugin
export default {"button":"LabeledButton_button__dDlkj"};